module.exports = __webpack_public_path__ + "static/media/wholesaler-blue-icon.4e902c2a.svg";